import { produktbild } from '../assets/product-images.js';

/**
 * Technische Schnittdarstellung des Artikeltyps.
 *
 * Zwei Groessen: `gross` im Kopf der Katalogtabelle, wo die Zeichnung `d1`, `d2`,
 * `s1` und `s2` beschriftet und damit die Spalten darunter unmittelbar erklaert
 * (bei G-ST-P/GR zusaetzlich `d3`, siehe Alt-Text unten); `thumbnail` in
 * Trefferlisten zur schnellen Wiedererkennung.
 *
 * Fehlt das Bild, wird **nichts** gezeigt -- kein Platzhalter und kein kaputtes
 * Bildsymbol.
 */
export function ProductImage({
  imageRef,
  variant,
  label,
}: {
  imageRef: string | null | undefined;
  variant: 'gross' | 'thumbnail';
  label: string;
}): React.JSX.Element | null {
  const quelle = produktbild(imageRef);
  if (quelle === null) return null;

  return (
    <img
      className={variant === 'gross' ? 'produktbild' : 'produktbild-thumb'}
      src={quelle}
      alt={
        variant === 'gross'
          ? // G-ST-P/GR fuehrt zusaetzlich den Profildurchmesser d3 -- die einzige
            // Familie mit drei Durchmessern, siehe GuidedSelection.tsx.
            `Technische Schnittdarstellung ${label} mit den Massen ` +
            (imageRef === 'g-st-gr' ? 'd1, d2, d3, s1 und s2' : 'd1, d2, s1 und s2')
          : label
      }
      /*
       * Ausdruecklich **ohne** `loading="lazy"`. Es gibt systemweit genau drei
       * Bilddateien; nach dem ersten Abruf liegen sie im Browsercache. Lazy-Loading
       * spart hier nichts, verhindert aber die Anzeige, sobald der Browser die
       * Sichtbarkeit nicht bestimmen kann -- etwa in einem Hintergrundfenster.
       */
      decoding="async"
    />
  );
}
